module.exports = __webpack_public_path__ + "static/media/silestone-xm-background-img.a38f09f0.png";